/*** Resolves Plus and minus quantity buttons (PDP <quantity-input>) ***/
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("quantity-input .minus, quantity-input .plus").forEach(button => {
        button.addEventListener("click", function () {
            const wrapper = this.closest("quantity-input");
            const input = wrapper && wrapper.querySelector(".quantity__input");
            if (!input) return;

            let value = parseInt(input.value, 10);
            const min = parseInt(input.min, 10) || 1;
            const max = input.max ? parseInt(input.max, 10) : null;
            const step = parseInt(input.step, 10) || 1;

            if (isNaN(value)) value = min;

            if (this.classList.contains("minus")) {
                value = Math.max(min, value - step);
            } else if (this.classList.contains("plus")) {
                value = max !== null ? Math.min(max, value + step) : value + step;
            }

            input.value = value;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    });
});

/*** Customer Registration ***/
// document.addEventListener(‘DOMContentLoaded’, function() {
//   document.getElementById(‘registerForm’).addEventListener(‘submit’, function(event) {
//     var phone = document.getElementById(‘Phone’).value;
//     if (!/^\d{10}$/.test(phone)) {
//       alert(‘Please enter a valid 10-digit phone number.’);
//       event.preventDefault();
//     }
//   });
// });


/*** Refresh cart on input change ***/
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".cart-quantity-input").forEach(input => {
        input.addEventListener("change", function () {
            let line = this.getAttribute("data-line"); // Get Shopify's line item ID
            let quantity = parseInt(this.value, 10);

            if (quantity < 1 || isNaN(quantity)) {
                quantity = 1; // Prevent invalid numbers
                this.value = 1;
            }

            updateCartItem(line, quantity);
        });
    });

    document.querySelectorAll(".cart-page-plus, .cart-page-minus").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent button default behavior (if any)

            let input = this.closest(".cart-item").querySelector(".cart-quantity-input");
            let line = input.getAttribute("data-line"); // Get Shopify's line item ID
            let quantity = parseInt(input.value, 10) || 1;

            if (this.classList.contains("cart-page-plus")) {
                quantity++;
            } else if (this.classList.contains("cart-page-minus") && quantity > 1) {
                quantity--;
            }

            input.value = quantity;
            input.dispatchEvent(new Event("change")); // Trigger change event to refresh cart
        });
    });

    function updateCartItem(line, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                id: line, 
                quantity: quantity 
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Cart updated:', data);
            updateCartUI(data); // Update cart without reloading
        })
        .catch(error => console.error('Error updating cart:', error));
    }

    function updateCartUI(cart) {
        // Example: Updating total price dynamically
        document.querySelector(".cart-total").innerText = `£${(cart.total_price / 100).toFixed(2)}`;
        
        // Example: Updating individual item prices
        cart.items.forEach(item => {
            let itemElement = document.querySelector(`[data-line="${item.id}"]`);
            if (itemElement) {
                itemElement.closest(".cart-item").querySelector(".cart-item-total").innerText = `£${(item.line_price / 100).toFixed(2)}`;
            }
        });
    }
});
